import _ from 'lodash';
import moment from 'moment';
import AppConfig from '../appConfig';
import numeral from 'numeral';

export const getRelativePath = (locationPath) => {
    if (window.location.hostname !== 'localhost') {
        locationPath = locationPath.replace(locationPath.split('/').splice(0, 2).join('/'), '');
    } else {
        locationPath = locationPath;
    }

    locationPath = _.trimEnd(_.trimStart(locationPath, '/'), '#').toLowerCase();

    return locationPath;
};

export const getMajorMenuName = (pathname) => {
    const path = pathname.split('/');
    if (path.length > 0) {
        return path[0].toLowerCase()
    }
    return '';
};

export const getFormattedTiming = (dateTime, formateType) => {
    if (!dateTime) return '';
    if (formateType) {
        return moment(dateTime).format(formateType);
    }
    return moment(dateTime).format('MM/DD/YYYY');
};

export const getMonthName = (date) => {
    if (!date) return '';
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return monthNames[date.getMonth()]
};

export const getUserId = () => {
    return localStorage.getItem('userId') ? localStorage.getItem('userId') : AppConfig.env('userId');
};

export const frequencyItem = (item) => {
    if (item == 1) {
        item = "Yearly"
    }
    else if (item == 2) {
        item = "Half-Yearly"
    }
    else if (item == 4) {
        item = "Quarterly"
    }
    else if (item == 12) {
        item = "Monthly"
    }
    else if (item == 99) {
        item = ""
    }
    return item;
};

export const formatAmount = (value, isShowSign, allowZero, showDecimal) => {
    if (!isShowSign) { isShowSign = false; }
    if (value === null) {
        return '';
    }
    if (value === 0 || value === '0' || value === '') {
        return allowZero ? (isShowSign ? '$0' : 0) : '';
    }
    else {
        if (showDecimal) {
            return (isShowSign ? (numeral(value).format('$0,0.[00]')) : (numeral(value).format('0,0.[00]')));
        } else {
            var value2 = value < 0 ? (Math.round(Math.abs(value)) * Math.sign(value)) : value;
            return (isShowSign ? (numeral(value2).format('$0,0')) : (numeral(value2).format('0,0')));
        }
    }
};

/**
 * Method to check string/object is null or undefined
 * @return {bool} true/false
 */
export const isEmpty2 = function (value, allowEmptyString) {
    return (value === ' ') || (value === null) || (value === undefined) || (!allowEmptyString ? value === '' : false) || (isArray(value) && value.length === 0);
};
/**
* Method to check object is array or not
* @return {bool} true/false
*/
export const isArray = ('isArray' in Array) ? Array.isArray : function (value) {
    return toString.call(value) === '[object Array]';
};


export const getFinancialYear = () => {
    var date = new Date();
    var reverseYear = [];
    for (var i = 2019; i <= date.getFullYear(); i++) {
        const collection = {
            value: i,
            label: i + "-" + (parseInt(i.toString().substring(2)) + 1)
        }
        reverseYear.push(collection);
    }
    return reverseYear.reverse();

}
